import React from "react";
import styles from "../ApplyForWC.module.css";

interface IApplyForWCComponentProps {}

const ApplyForWCComponent = ({
  ...props
}: IApplyForWCComponentProps): JSX.Element => {
  return (
    <>
      <div className={styles.landingPagecontainer}>
        <div className={styles.title}>What to expect</div>

        <p className={styles.description}>
          We’ll ask about your business, owners, and employees so we can quickly
          get you an accurate quote.
        </p>
        <p className={styles.descriptionCopyForDesktop}>
          We’ll save your progress so you can take a break if you need to find
          some paperwork or get a coffee.
        </p>
        <p className={styles.descriptionCopyForMobile}>
          We’ll save your progress so you can take a break if you want to switch
          to desktop, find some paperwork, or get a coffee.
        </p>
      </div>
    </>
  );
};

export default ApplyForWCComponent;
